export const letterSpacing = {
  "sys-tight": "-0.2%",
};
